import { useFlags } from "launchdarkly-react-client-sdk";

/**
 * The one predicate every launch affordance consults, so they cannot diverge.
 * `disableAdStudioLaunch` is an interim workspace-level kill switch for
 * launching ads to Meta, ahead of a real launch permission, and is inverted
 * deliberately — `true` hides the feature.
 *
 * Reads as enabled until LaunchDarkly resolves, which is the right default for
 * anything that renders: at worst a kill-switched workspace sees a brief flash
 * of the launch chrome rather than every other workspace losing it on a cold
 * load. The server-side guard on `launchAds`/`relaunchMetaAd` is what actually
 * enforces the switch.
 */
export const useIsAdStudioLaunchEnabled = (): boolean => {
  const { disableAdStudioLaunch } = useFlags();

  return !disableAdStudioLaunch;
};
